import { PersonalDetailsAction } from '../actions/PersonalDetailsAction'
import { SequenceManagerAction } from '../actions/SequenceManagerAction'

const initState = {
    requestBody: {
        sectionId: "personalDetails",
        steps: [
            {
                sequence: "0",
                stepId: "personalDetails",
                fields: [
                    {
                        name: "First Name",
                        value: ""
                    },
                    {
                        name: "Middle Name",
                        value: ""
                    },
                    {
                        name: "Last Name",
                        value: ""
                    },
                    {
                        name: "Phone number",
                        value: ""
                    },
                    {
                        name: "Email",
                        value: ""
                    },
                    {
                        name: "BirthdayDate",
                        value: ""
                    }
                ],
                options: [
                    {
                        name: "BirthdayType",
                        value: ""
                    }
                ]
            }
        ],
    }
}

const PersonalDetailsReducer = (state: any = initState, action: any) => {
    const { type } = action;
    const { payload } = action;
    var PersonalDetailsValue = { ...state.requestBody.steps };

    switch (type) {
        case PersonalDetailsAction.PERSONAL_DETAILS_SUCCESS:
            PersonalDetailsValue[0].fields[0].value = payload.fName;
            PersonalDetailsValue[0].fields[1].value = payload.mName;
            PersonalDetailsValue[0].fields[2].value = payload.lName;
            PersonalDetailsValue[0].fields[3].value = payload.phone;
            PersonalDetailsValue[0].fields[4].value = payload.email;
            PersonalDetailsValue[0].fields[5].value = payload.birthDate;
            PersonalDetailsValue[0].options[0].value = payload.birthdayType;
            return state;

        case SequenceManagerAction.GET_CHECKOUT_SUCCESS:
            let section = payload.sections.filter((section: any) => {
                return (section.sectionId === 'personalDetails')
            });
            if(section.length > 0) {
                for (let i = 0; i < PersonalDetailsValue[0].fields.length; i++) {
                    const PersonalDetailsField = section[0].steps[0].fields.filter((field: any) => { return (field.name === PersonalDetailsValue[0].fields[i].name) })[0];
                    PersonalDetailsValue[0].fields[i].value = PersonalDetailsField ? PersonalDetailsField.value : "";
                }
                for (let i = 0; i < PersonalDetailsValue[0].options.length; i++) {
                    const PersonalDetailsOption = section[0].steps[0].options.filter((field: any) => { return (field.name === PersonalDetailsValue[0].options[i].name) })[0];
                    PersonalDetailsValue[0].options[i].value = PersonalDetailsOption ? PersonalDetailsOption.value : "";
               }
            }
            return state;
            
         default:
            return state;
    }
}

export default PersonalDetailsReducer;